'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var index_es = require('../../../../node_modules/@fortawesome/react-fontawesome/index.es.cjs');
var React = require('react');

/**
 * A wrapper around the original FontAwesomeIcon component which overrides the default titleId prop
 * This is needed because of hydration mismatch issues during (SSR) Server Side Rendering
 *
 * @param {FontAwesomeIconProps} props - Props to passthrough to the FontAwesomeIcon component
 * @returns {FontAwesomeIcon} The patched FontAwesomeIcon component with a overwritten titleId
 */ const FontAwesomeIcon = (props)=>{
    // titleId as generated internally within FontAwesomeIcon produces a different version in client/server
    // To fix this problem, we can pass it in manually using useId which will produce the same value on client and server
    // Fixing upstream is challenging as they don't accept PRs and all the open source code is the built/minified code, patching is far easier here
    const titleId = React.useId();
    return /*#__PURE__*/ jsxRuntime.jsx(index_es.FontAwesomeIcon, {
        titleId,
        ...props
    });
};

exports.FontAwesomeIcon = FontAwesomeIcon;
//# sourceMappingURL=react-fontawesome.cjs.map
